import type { TxConnectionConfig, TxEngineConfig } from '../config.js';
import type { SubmissionOptions } from '../types.js';

export function resolveSubmissionConnectionConfig(
  options: SubmissionOptions,
  cfg: TxEngineConfig,
): TxConnectionConfig {
  const scope = options.connectionScope;
  if (scope === undefined) return cfg.resolveConnectionConfig();
  scope.config ??= cfg.resolveConnectionConfig();
  return scope.config;
}
